import { useEffect, useState } from "react";
import styled from "styled-components";
import { SYSTEM_AVATAR_BY_KEY } from "./systemAvatars";

const StyledUserAvatar = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
  border-radius: 50%;
  overflow: hidden;
  background: #22307a;
  color: #fcfdfe;
  font-size: ${props => Math.round(props.$size * 0.36)}px;
  font-weight: 500;
  line-height: 1;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  svg {
    display: block;
  }
`;

/**
 * @param {?Object} user
 * @return {string} Up to two uppercase initials, or "SU" for super users.
 */
export const getUserInitials = user => {
  if (user?.is_superuser) return "SU";
  const parts = (user?.full_name || user?.email || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  const letters = parts.length > 1 ? parts[0][0] + parts[parts.length - 1][0] : parts[0][0];
  return letters.toUpperCase();
};

/**
 * Circular user picture: uploaded photo, else system avatar, else initials.
 *
 * @param {{
 *   user: ?{profile_photo: ?string, avatar_key: ?string, full_name: ?string, email: ?string},
 *   size: (number|undefined),
 *   className: (string|undefined),
 * }} props
 * @return {JSX.Element}
 */
export const UserAvatar = ({ user, size = 40, className }) => {
  const photo = user?.profile_photo || "";
  const [failedPhoto, setFailedPhoto] = useState("");

  useEffect(() => setFailedPhoto(""), [photo]);

  const showPhoto = photo && failedPhoto !== photo;
  const SystemAvatar = !showPhoto && SYSTEM_AVATAR_BY_KEY[user?.avatar_key];

  return (
    <StyledUserAvatar $size={size} className={className} aria-hidden="true">
      {showPhoto ? (
        <img src={photo} alt="" onError={() => setFailedPhoto(photo)} />
      ) : SystemAvatar ? (
        <SystemAvatar />
      ) : (
        getUserInitials(user)
      )}
    </StyledUserAvatar>
  );
};
